import React from 'react'
import { IJob } from '../interfaces/IJob'
import { Job } from './Job'

interface JobsListProps {
  jobs: readonly IJob[]
}

export const JobsList = ({ jobs }: JobsListProps) => {
  return (
    <div className='flex flex-wrap md:grid md:grid-cols-2 gap-8'>
      {jobs.map(({ id, title, slug, excerpt }: IJob) => (
        <Job key={id} id={id} title={title} slug={slug} excerpt={excerpt} />
      ))}
    </div>
  )
}